var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagineLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "142px",
    height: "31px",
    viewBox: "0 0 142 31",
    style: {
      enableBackground: "new 0 0 142 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "45.6,14.1 52,3.1 58.3,14.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.6,
    className: "st0",
    width: 2.5,
    height: 17.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "32.2,18.2 29.7,18.2 28.6,4.3 28.5,4.3 23.1,18.4 21.7,18.4 16.3,4.3 16.3,4.3 15.1,18.2 12.7,18.2  14.3,0.6 17.3,0.6 22.4,14.2 22.5,14.2 27.5,0.6 30.6,0.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81,15.7c-0.3,0.3-2.5,2.9-7.5,2.9c-5,0-9-3.6-9-9.1c0-5.5,4-9.1,8.9-9.1c4.5,0,6.5,2.4,7.1,3.1L79,5 c-1-1.2-2.7-2.5-5.4-2.5c-3.6,0-6.4,2.6-6.4,6.9c0,4.3,2.9,6.9,6.6,6.9c3.6,0,4.9-1.6,4.9-1.6v-3.9h-4.7v-2H81V15.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.8,
    y: 0.6,
    className: "st0",
    width: 2.5,
    height: 17.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.2,18.2h-2.4l-10.1-14c0,0,0.1,2.4,0.1,4.7v9.4h-2.4V0.6h2.6l10,13.8c0,0,0-2.2,0-4.5V0.6h2.4V18.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "141.8,18.2 131.3,18.2 131.3,0.6 141.6,0.6 141.6,2.7 133.7,2.7 133.7,8 141.1,8 141.1,10 133.7,10  133.7,16.1 141.8,16.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.8,29.7c-0.4,0.4-1.1,0.9-2.2,0.9c-1.8,0-3.1-1.2-3.1-3.1c0-1.9,1.4-3.1,3.1-3.1c1.1,0,1.8,0.5,2.1,0.8 l-0.4,0.7c-0.2-0.3-0.9-0.7-1.7-0.7c-1.3,0-2.2,0.9-2.2,2.3c0,1.4,1,2.3,2.2,2.3c0.8,0,1.4-0.3,1.8-0.7L96.8,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.8,30.5h-0.9l-0.6-1.6h-2.6l-0.6,1.6h-0.9l2.5-6h0.7L105.8,30.5z M104,28.2l-1.1-2.7l-1.1,2.7H104z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.8,30.5h-0.8l-3.5-4.8c0,0,0,0.8,0,1.6v3.2h-0.8v-6h0.9l3.4,4.7c0,0,0-0.7,0-1.5v-3.2h0.8V30.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.2,30.5h-0.9l-0.6-1.6h-2.6l-0.6,1.6h-0.9l2.5-6h0.7L124.2,30.5z M122.4,28.2l-1.1-2.7l-1.1,2.7H122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.1,29.7c-0.4,0.4-1.2,0.8-2.3,0.8h-1.8v-6h1.8c1,0,1.8,0.4,2.3,0.8c0.4,0.4,0.9,1.1,0.9,2.2 C133,28.6,132.6,29.3,132.1,29.7 M131.5,25.8c-0.3-0.3-0.9-0.6-1.6-0.6h-1v4.6h1c0.7,0,1.3-0.2,1.6-0.6c0.3-0.3,0.7-0.8,0.7-1.7 C132.2,26.6,131.8,26.1,131.5,25.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142,30.5h-0.9l-0.6-1.6h-2.6l-0.6,1.6h-0.9l2.5-6h0.7L142,30.5z M140.2,28.2l-1.1-2.7l-1.1,2.7H140.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "51.1,4.6 49.8,6.9 54,14.1 56.6,14.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.9,14.7h-2.7L55,16H42.3l6.4-11l0.8,1.4L50.8,4l-1.7-3c-0.2-0.3-0.7-0.3-0.9,0l-9.5,16.5 c-0.2,0.3,0,0.7,0.4,0.7h19.1c0.4,0,0.6-0.4,0.4-0.7L56.9,14.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagineLogo);
export default __webpack_public_path__ + "static/media/imagine-logo.6317e69eca21c086252986d3b9a3f655.svg";
export { ForwardRef as ReactComponent };